import JsxHelper from '../../../Helpers/JsxHelper';
import React from 'react';
import RedirectLinkComponent from '../../../Elements/RedirectLinkComponent';
import LookupText from '../../../Elements/LookupText';

export default class ThirdPartyJobPaymentForExportPaymentItem {
  constructor(item) {
    this.initialize(item);
    this.Selected = false;
  }

  initialize(item) {
    this.TpEvaluatorTpJobPaymentId = item.tpEvaluatorTpJobPaymentId;
    this.TpJobId = item.tpJobId;
    this.TpEvaluatorId = item.tpEvaluatorId;
    this.Comment = item.comment;
    this.ExportId = item.exportId;
    this.ExportPaymentId = item.exportPaymentId;
    this.CheckId = item.checkId;
    this.EvaluatorPaymentOfficeId = item.evaluatorPaymentOfficeId;
    this.AssignedOnUtc = item.assignedOnUtc;
    this.AssignedTo = item.assignedTo;
    this.SubmittedOnUtc = item.submittedOnUtc;
    this.SubmittedBy = item.submittedBy;
    this.ApprovedOnUtc = item.approvedOnUtc;
    this.ApprovedBy = item.approvedBy;
    this.StatusCodeLookupValue = item.statusCodeLookupValue;
    this.TypeText = item.typeText;
    this.ReissuedFromTpEvaluatorTpJobPaymentId = item.reissuedFromTpEvaluatorTpJobPaymentId;
    this.VoidReason = item.voidReason;
    this.ClientName = item.clientName == null ? '' : item.clientName;
    this.EvaluatorName = item.evaluatorName == null ? '' : item.evaluatorName;
    this.PaymentTypeText = item.paymentTypeText;
    this.CreatedBy = item.createdBy;
    this.CreatedOnUtc = item.createdOnUtc;
    this.ModifiedBy = item.ModifiedBy;
    this.ModifiedOnUtc = item.modifiedOnUtc;
    this.ThirdPartyJobId = item.thirdPartyJobId;
    // CD-5421: from the related TpJob - the shop was paid to the evaluator outside Bravo.
    this.PaidOutsideOfSystem = item.paidOutsideOfSystem;
    this.Fee = item.fee;
    this.FeeAdjustment = item.feeAdjustment;
    this.Expense = item.expense;
    this.Vat = item.vat;
    this.Total = item.total;
    this.TotalFee = item.fee + item.feeAdjustment;
    this.TotalDisplay = item.totalDisplay;
    this.Paid = item.paid;
    this.PaidDisplay = item.paidDisplay;
    this.Due = item.due;
    this.CreatedOnUtc = item.createdOnUtc;
    this.EvaluatorCurrencyCode = item.evaluatorCurrencyCode;
    this.EvaluatorCurrencySymbol = item.evaluatorCurrencySymbol;
    this.ThirdPartyLocationName = item.thirdPartyLocationName;
    this.EvaluatorOfficeName = item.evaluatorOfficeName;
    this.PaymentDate = item.paymentDate == null ? '' : item.paymentDate;
    this.ReissuedToTpEvaluatorTpJobPaymentId = item.reissuedToTpEvaluatorTpJobPaymentId;
    this.ReissuedFromTpEvaluatorTpJobPaymentId = item.reissuedFromTpEvaluatorTpJobPaymentId;
    this.Reimbursement = item.reimbursement;
    this.Misc = item.misc;
    this.Travel = item.travel;
    this.Gaming = item.gaming;
    this.ExportId = item.ExportId;
    this.FeeDisplay = item.feeDisplay;
    this.ProjectId = item.projectId == null ? '' : item.projectId;
    this.ProjectName = item.projectName == null ? '' : item.projectName;
    this.ProjectIdAndName = this.ProjectId === '' ? '' : `${this.ProjectId} - ${this.ProjectName}`;
    this.JobDate = item.jobDate;
    this.ThirdPartyLocationCountry = item.thirdPartyLocationCountry;
    this.FieldworkOfficeId = item.fieldworkOfficeId;
    this.FieldworkOfficeName = item.fieldworkOfficeName;
    this.InfoRequested = item.infoRequested;
  }

  static NameOfTheIdField() {
    return 'TpEvaluatorTpJobPaymentId';
  }

  static nameOfTheItemDetailList() {
    return 'Evaluator Payment';
  }

  static MoneyFields = ['TotalFee', 'Expense', 'Vat'];

  static Currency() {
    return 'EvaluatorCurrencyCode';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateOnlyFields = ['JobDate'];
  static DateFields = ['JobDate'];

  static BoolFields = [];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Evaluator', orderById: 'EvaluatorName', data: 'EvaluatorName', minWidth: 50 },
      {
        label: 'Third-Party Job ID',
        orderById: 'ThirdPartyJobId',
        data: ThirdPartyJobPaymentForExportPaymentItem.idFunction,
        minWidth: 70,
      },
      { label: 'Client', orderById: 'ClientName', data: 'ClientName', minWidth: 50 },
      { label: 'Project (ID)', orderById: 'ProjectName', data: 'ProjectIdAndName', minWidth: 50 },
      { label: 'Type', orderById: 'TypeText', data: 'TypeText', minWidth: 50 },
      {
        label: 'Status',
        orderById: 'Status',
        data: (item) => (
          <LookupText
            lookupId={45}
            value={item.StatusCodeLookupValue}
          />
        ),
        minWidth: 50,
      },
      // CD-5421: sits directly after Status on purpose - it is what explains a Closed payment.
      {
        label: 'Paid Outside of System',
        orderById: 'PaidOutsideOfSystem',
        data: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem),
        minWidth: 20,
      },
      { label: 'Total Fee', orderById: 'TotalFee', data: 'TotalFee', minWidth: 50 },
      { label: 'Expenses', orderById: 'Expense', data: 'Expense', minWidth: 50 },
      { label: 'Tax', orderById: 'Vat', data: 'Vat', minWidth: 50 },
      { label: 'Location', orderById: 'ThirdPartyLocationName', data: 'ThirdPartyLocationName', minWidth: 50 },
      { label: 'Country', orderById: 'ThirdPartyLocationCountry', data: 'ThirdPartyLocationCountry', minWidth: 50 },
      { label: 'Shop Date', orderById: 'JobDate', data: 'JobDate', minWidth: 50 },
    ];
  }

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        isFigmaStyle={true}
        path='tpevaluatortpjobpayments'
        tooltipText={item.ThirdPartyJobId}
        text={item.ThirdPartyJobId}
        keyValuePairs={[
          { key: 'TabType', value: 'all_payments' },
          { key: 'ThirdPartyJobId', value: item.ThirdPartyJobId },
          { key: 'SelectedPaymentOffices', value: '' },
        ]}
      />
    );
  }
}
